import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = [ "activationForm" ]
  connect() {
  }

  toggleActivation(event) {
    event.preventDefault();
    event.stopPropagation();
    this.activationFormTarget.requestSubmit();
  }
}
